import { render } from "./play_circle.svg?vue&type=template&id=755c9178"
const script = {}
script.render = render

export default script